import type { ButtonHTMLAttributes, ReactNode } from 'react';
import './button.css';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'ghost' | 'danger' | 'toggle';
  active?: boolean;
  children: ReactNode;
}

/** Basis-Button im "Soft Studio"-Stil. */
export function Button({ variant = 'primary', active = false, className, children, ...rest }: ButtonProps) {
  const classes = ['btn', `btn--${variant}`, active ? 'btn--active' : '', className ?? ''].join(' ').trim();
  return (
    <button className={classes} {...rest}>
      {children}
    </button>
  );
}
